import type { I18n } from 'vue-i18n'

import type { RoleEnumTypeV2 } from '@/features/auth/types'
import { PermissionsGroupsEnumType, ProgramUserRolesType } from '@/features/auth/types'
import dayjsClient from '@/lib/dayjs'
import { switchI18nLanguage, type TranslationKeysType } from '@/lib/i18n'

export const userRolesNamesMap = {
  ADMIN: 'common.admin.capitalize',
  MANAGER: 'common.manager.capitalize',
  MENTOR: 'common.mentor.capitalize',
  MENTEE: 'common.mentee.capitalize',
  SUPPORT: 'common.support.capitalize',
} as Record<RoleEnumTypeV2, TranslationKeysType>

const PERMISSIONS_GROUPS = {
  [PermissionsGroupsEnumType.ADMIN]: [ProgramUserRolesType.ADMIN, ProgramUserRolesType.MANAGER, ProgramUserRolesType.SUPPORT],
  [PermissionsGroupsEnumType.USER]: [ProgramUserRolesType.MENTEE, ProgramUserRolesType.MENTOR],
} as const

// return the permissions group for a given role
function checkPermissionsGroup(
  role: RoleEnumTypeV2 | RoleEnumTypeV2[] | undefined,
  permissionGroup: PermissionsGroupsEnumType,
): boolean {
  if (Array.isArray(role)) {
    return role.some((r) => PERMISSIONS_GROUPS[permissionGroup].includes(r as never))
  }
  return PERMISSIONS_GROUPS[permissionGroup].includes(role as never)
}

export default checkPermissionsGroup

/**
 * Switches the application language and updates related configurations.
 */
export async function switchLanguage(locale: string, i18nInstance: I18n) {
  await switchI18nLanguage(i18nInstance, locale)
  dayjsClient.locale(locale)
}
